import { useTranslation } from 'react-i18next';
import { EnumStatuses } from 'src/models/enums';

const useStatusesTranslate = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'statuses',
  });
  const statusesTypesMap: {
    [key: string]: string;
  } = {
    [EnumStatuses.NEW]: t('NEW'),
    [EnumStatuses.ACCEPTED]: t('ACCEPTED'),
    [EnumStatuses.IN_PROGRESS]: t('IN_PROGRESS'),
    [EnumStatuses.DONE]: t('DONE'),
    [EnumStatuses.REFUND]: t('REFUND'),
    [EnumStatuses.REJECTED]: t('REJECTED'),
    [EnumStatuses.TRASH]: t('TRASH')
  };
  return statusesTypesMap;
};
export default useStatusesTranslate;
